module.exports=[
  {
    "title": "My Introduction to Steemit!",
    "description": "Hi Steemit community!",
    "image": "https://steemitimages.com/0x0/https://cdn.steemitimages.com/DQmUv4GLGraXJXMrWrHB9LMPMERNSZMWfnScGSPxLDJLwRZ/profile.jpg",
    "link": "https://steemit.com/introduceyourself/@bernardoanderson/my-introduction-to-steemit"
  }
]
